<template>
  <!-- overflow: hidden; -->
  <div
    ref="personTargetRef"
    :style="wrapperStyle"
  >
    <div
      v-show="!hidePanel"
      class="row justify-left q-py-sm no-wrap global_container"
      :style="'width: 100%; min-width: 880px;'"
    >
      <MostaSelect
        v-if="!isSector && !isInDialog"
        v-model="widthModel"
        :options="widthOptions"
        class="q-mr-xs"
        style="min-width: 180px; margin-top: 6px;"
      />
      <button
        v-if="genstore.selectedItem && genstore.selectedItem.Id"
        type="button"
        :class="['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': isSector }]"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        "
        @click="onRefreshTable(pagination)"
        :aria-label="$t('refresh_label')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53683 17.3559C7.08197 17.0665 5.7456 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.07091 7.12987C3.63856 5.75943 4.59986 4.58809 5.83323 3.76398C7.0666 2.93987 8.51664 2.5 10 2.5C12.1 2.5 14.1083 3.33333 15.6167 4.78333L17.5 6.66667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 2.5V6.66667H13.3333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300" anchor="top middle" self="center middle">{{ $t('refresh_label') }}</q-tooltip>
      </button>
      <button
        v-if="
          (genstore.selectedItem &&
            genstore.selectedItem.DestType !== 6 &&
            [0, 1].includes(genstore.selectedItem.elType) &&
            querystore.getCurrentTable &&
            querystore.getCurrentTable.HeaderRow &&
            querystore.getCurrentTable.HeaderRow.length) ||
          isSector
        "
        type="button"
        :class="['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': isSector }]"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        "
        @click="
          saveTableToFile(
            genstore.selectedItem,
            genstore.selectedItem ? genstore.selectedItem.Name : ''
          )
        "
        :aria-label="$t('load')"
        :disabled="querystore.isLoading || auxstore.isTableLoading"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 12.5V2.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.83331 8.33337L9.99998 12.5L14.1666 8.33337" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300" anchor="top middle" self="center middle">{{ $t('load') }}</q-tooltip>
      </button>
      <button
        v-if="genstore.selectedItem"
        type="button"
        :class="['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': isSector }]"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        "
        @click="copyLinkToItem"
        :aria-label="$t('copy_link')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5 6C15.3284 6 16 5.32843 16 4.5C16 3.67157 15.3284 3 14.5 3C13.6716 3 13 3.67157 13 4.5C13 5.32843 13.6716 6 14.5 6Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.5 11C6.32843 11 7 10.3284 7 9.5C7 8.67157 6.32843 8 5.5 8C4.67157 8 4 8.67157 4 9.5C4 10.3284 4.67157 11 5.5 11Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.15833 11.2583L12.85 14.575" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.8417 5.42505L7.15833 8.74172" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300" anchor="top middle" self="center middle">{{ $t('copy_link') }}</q-tooltip>
      </button>

      <div
        class="q-mx-xs text-h8"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        "
      >
        {{ $t("table_rows_count") }} {{ formattedTotalCount }}
      </div>
      <div
        v-show="multieditAllowed"
        class="q-mx-xs text-h8 q-ml-md"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        "
      >
        {{ $t("selected_label") }}
        {{
          headerCheckbox === "none"
            ? selectedModel.length
            : Number(pagination.total_count) - Number(unselectedModel.length)
        }}
      </div>

      <q-space />

      <div
        class="text-h8"
        :style="
          (!isSector && !isInDialog ? 'margin-top: 14px;' : 'margin-top: 8px;') +
          ' white-space: nowrap;'
        "
      >
        {{ $t("records_on_page") }}
      </div>
      <!-- <q-select
        flat
        v-model="countModel"
        class="q-mb-sm q-mr-lg"
        fill-input
        :bottom-slots="false"
        dense
        input-debounce="500"
        ref="count_select"
        :options="countOptions"
      /> -->
      <q-input
        v-model.number="countOnPage"
        type="number"
        dense
        class="thin-input q-mx-sm"
        outlined
        @blur="applyCountOnPage"
        @keydown.enter.stop.prevent="applyCountOnPage"
        :style="`max-width: 70px; min-width: 70px; ${
          !isSector && !isInDialog ? 'margin-top: 10px;' : 'margin-top: 4px;'
        } font-size: 16px !important;`"
      />
      <div
        class="text-h8 q-mx-sm"
        :style="
          !isSector && !isInDialog ? 'margin-top: 14px;' : 'margin-top: 8px;'
        "
      >
        <span v-if="modelValue && modelValue.SavedStateCalculatedAt"
          >&nbsp;{{ $t("current_at") }}&nbsp;{{ lastCalcDate }}</span
        >
      </div>
      <button
        class="mini-nav-btn"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 11px;'
            : 'margin-top: 5px;'
        "
        @click="prevPage"
        :disabled="
          querystore.isLoading ||
          auxstore.isTableLoading ||
          (!isSector && !theModel) ||
          pagination.offset <= 0
        "
        :aria-label="$t('prev_page')"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div
        class="text-h8"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        "
      >
        {{ $t("page") }}
      </div>
      <q-input
        v-model.number="pageNum"
        type="number"
        dense
        class="thin-input q-mx-sm"
        outlined
        @blur="applyPageNum"
        @keydown.enter.stop.prevent="applyPageNum"
        :style="`max-width: 70px; min-width: 70px; ${
          !isSector && !isInDialog ? 'margin-top: 10px;' : 'margin-top: 4px;'
        } font-size: 16px !important;`"
      />
      <div
        class="text-h8"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        "
      >
        /{{ pagesCount }}
      </div>
      <button
        class="mini-nav-btn"
        :style="
          !isSector && !isInDialog
            ? 'margin-top: 11px;'
            : 'margin-top: 5px;'
        "
        @click="nextPage"
        :disabled="
          querystore.isLoading ||
          auxstore.isTableLoading ||
          (!isSector && !theModel) ||
          currentPage >= pagesCount
        "
        :aria-label="$t('next_page')"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <!--
      В standalone-режиме делаем table_container flex-ребёнком обёртки на всю
      оставшуюся высоту и flex-колонкой с min-height:0/overflow:hidden. Без этого
      QueryTableLite со своим flex:1 растягивался бы по контенту и выталкивал
      родительскую панель за экран — нужна именно ограниченная высота, чтобы
      скроллилось только тело таблицы (шапка поверх).
    -->
    <div
      :style="`${
        !isSector && !isInDialog
          ? 'flex: 1 1 0; min-height: 0; display: flex; flex-direction: column; overflow: hidden; background: transparent;'
          : ''
      } `"
      ref="table_container"
      class="table_container"
    >
      <!--
        Lite-таблица. Тулбары/счётчики вокруг остаются от QueryTable.vue. Lite
        принимает те же v-model + pagination/selection пропы. Высоту задаёт сам
        через .qtl-shell--standalone; внешней обёртки нет, иначе она бы сдвинула
        панель QueryTable за viewport.
      -->
      <QueryTableLite
        v-model="theModel"
        :src-element="srcElement"
        :paginationModel="pagination"
        :selectedEverything="selectedEverything"
        :selectedEntities="selectedEntities"
        :unselectedEntities="unselectedEntities"
        :hide-panel="hidePanel"
        :is-sector="isSector"
        :is-in-dialog="isInDialog"
        @update:paginationModel="(v: any) => $emit('update:paginationModel', v)"
        @update:selectedEverything="(v: any) => emitSelectedAll(v)"
        @update:selectedEntities="(v: any) => emitSelected(v)"
        @update:unselectedEntities="(v: any) => emitUnselected(v)"
        @selectionChangeManual="emitSelectionChangeManual()"
        @refreshPage="(v: any) => emitRefreshPage(v)"
        @reloadTable="emitReloadTable(undefined)"
        @refreshNeeded="onRefreshTable(pagination, false)"
        @addCommentColumn="onAddCommentColumn"
        @multieditClick="onLiteMultieditClick"
        @togglePinnedOrder="globalPinnedOrder"
        @updatePerson="($event: any) => updatePerson($event.ev, $event.entityId)"
      />
      <mosta-context-menu
        :visible="liteMultieditMenuVisible"
        :position="liteMultieditMenuPos"
        :min-width="200"
        menu-class="ble-lite-menu ble-lite-menu--multiedit"
        @close="closeLiteMultieditMenu"
      >
        <div class="ble-lite-menu__item" @click.stop="onLiteMenuAction(5, 1, liteMenuText.addToList, undefined, $event)">
          {{ liteMenuText.addToList }}
        </div>
        <div
          v-if="srcElement && [6].includes(srcElement?.elType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(5, 2, liteMenuText.deleteFromList, undefined, $event)"
        >
          {{ liteMenuText.deleteFromList }}
        </div>
        <div class="ble-lite-menu__sep"></div>
        <div
          v-if="srcElement && ![7,8].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(4, 1, liteMenuText.deleteElements, undefined, $event)"
        >
          {{ liteMenuText.deleteElements }}
        </div>
        <div class="ble-lite-menu__sep"></div>
        <div
          v-if="srcElement && ![5,7,8].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(1, 1, liteMenuText.addTags, undefined, $event)"
        >
          {{ liteMenuText.addTags }}
        </div>
        <div
          v-if="srcElement && [5].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(1, 3, liteMenuText.changeTagsStatus, undefined, $event)"
        >
          {{ liteMenuText.changeTagsStatus }}
        </div>
        <div
          v-if="srcElement && ![5,7,8].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(1, 2, liteMenuText.removeTags, undefined, $event)"
        >
          {{ liteMenuText.removeTags }}
        </div>
        <div v-if="srcElement && [0,1].includes(srcElement?.DestType)" class="ble-lite-menu__sep"></div>
        <div
          v-if="srcElement && [0,1].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(15, 1, liteMenuText.addParameters, undefined, $event)"
        >
          {{ liteMenuText.addParameters }}
        </div>
        <div
          v-if="srcElement && [0,1,7].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(15, 2, liteMenuText.editParameter, undefined, $event)"
        >
          {{ liteMenuText.editParameter }}
        </div>
        <div
          v-if="srcElement && [0,1].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(15, 3, liteMenuText.deleteParameters, undefined, $event)"
        >
          {{ liteMenuText.deleteParameters }}
        </div>
        <!-- Инфо, комментарий и параметр правятся одним окном, поэтому у сегментов без
             пункта параметров он же открывается прежней точкой входа этого сегмента -->
        <div v-if="showDetailsEntry || showCommentEntry" class="ble-lite-menu__sep"></div>
        <div
          v-if="showDetailsEntry"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(6, 2, liteMenuText.changeDetails, 1, $event)"
        >
          {{ liteMenuText.editParameter }}
        </div>
        <div
          v-if="showCommentEntry"
          class="ble-lite-menu__item"
          @click.stop="onLiteMenuAction(6, 3, liteMenuText.changeComment, 1, $event)"
        >
          {{ liteMenuText.editParameter }}
        </div>
        <div v-if="srcElement && [0,1].includes(srcElement?.DestType)" class="ble-lite-menu__sep"></div>
        <div
          v-if="srcElement && [0,1].includes(srcElement?.DestType)"
          class="ble-lite-menu__item"
          @click.stop="openPermitionsModal()"
        >
        {{ `Изменить права` }}
        </div>
      </mosta-context-menu>

      <!-- Диалог массовой правки. Открывается пунктами lite-меню через tagMultieditDialog. -->
      <Teleport to="body">
        <div
          v-if="tagMultieditDialog"
          ref="multieditDialogWrap"
          class="med-dialog-popup"
          :style="multieditDialogPosStyle"
        >
          <multi-edit-dialog
            :entities="entitiesForMultiedit"
            :totalElements="
              headerCheckbox === 'none'
                ? selectedModel.length
                : Number(pagination.total_count) - Number(unselectedModel.length)
            "
            :all-checked="!isSector ? headerCheckbox !== 'none' : false"
            :model-type="multiEditType"
            :parameter-mode="multiEditMode"
            :comment-action-type="multiEditCommentAction"
            :header-text="multiEditHeader"
            :has-comment-column="hasTableCommentColumn"
            :details-edit-allowed="canEditDetails"
            :src-element="srcElement"
            @refreshNeeded="onMultiEditRefreshNeeded"
            @selectorClosed="closeMultieditDialog"
          />
        </div>
      </Teleport>

      <q-dialog
        v-model="personEditDialog"
        no-backdrop-dismiss
        class="person-dialog"
      >
        <person-edit-dialog
          :entityId="personEditData"
          :src-element="srcElement"
          :marginx="persMarginX"
          :marginy="persMarginY"
          @refreshNeeded="onRefreshTable(pagination, false)"
        />
      </q-dialog>
    </div>
  </div>
  <analytic-permition-modal
    ref="analyticPermitionModal"
    :title="'Изменение прав доступа'"
    @saved="onPermitionsSaved"
    />
</template>

<script lang="ts">
import {
  AnalyticsResultTableExtended,
} from "@/models/interfaces/entity-settings/querytable/querytable";
import {
  TableHeaderCell,
  TableHeaderCellContainer,
} from "@/models/interfaces/entity-settings/querytable/tableheader";
import { ColumnCategory } from "@/models/etc/types";
import MultiEditDialog from "@/components/multiedit/MultiEditDialog.vue";
import PersonEditDialog from "@/components/personedit/PersonEditDialog.vue";
import { Component, Prop, Vue, Watch, Emit, Setup } from "vue-facing-decorator";
import { BaseListItem } from "../base-list/interfaces/ListTypes";
import { buildClientUrl } from "@/utils/urlHelpers";
import { queryStore } from "@/store/querytable";
import { auxStore } from "@/store/auxillary";
import { isNumber } from "lodash";
import { generalStore } from "@/store/general";
import { settingsStore } from "@/store/settings";
import {
  clearCommentEditRequest,
  commentColumnBusy,
  requestCommentEdit,
} from "./refactored/commentColumn";
import { canEditStorageDetails } from "./refactored/notesAccess";
import { useQuasar } from "quasar";
import { date } from "quasar";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";
import MostaSelect from "@/components/common/MostaSelect.vue";
import QueryTableLite from './refactored/QueryTableLite.vue';
import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
import AnalyticPermitionModal from "@/components/permitions/AnalyticPermitionModal.vue";

@Component({
  name: "QueryTable",
  components: {
    MultiEditDialog,
    PersonEditDialog,
    MostaContextMenu,
    MostaSelect,
    QueryTableLite,
    MostaCheckbox,
    AnalyticPermitionModal
  },
})
export default class QueryTable extends Vue {
  @Prop({ default: undefined })
  modelValue?: AnalyticsResultTableExtended;
  @Emit("update:modelValue") emitModelValue(arg: any) {
    return arg;
  }
  @Emit("movePage") emitMovePage(arg: any) {
    return arg;
  }
  @Emit("refreshPage") emitRefreshPage(arg: any) {
    return arg;
  }
  @Emit("reloadTable") emitReloadTable(arg: any) {
    return arg;
  }

  @Prop({ default: "none" })
  selectedEverything?: string;
  @Prop({ default: undefined })
  selectedEntities?: number[];
  @Prop({ default: undefined })
  unselectedEntities?: number[];

  @Emit("update:selectedEverything") emitSelectedAll(arg: any) {
    return arg;
  }
  @Emit("update:selectedEntities") emitSelected(arg: any[]) {
    return arg;
  }
  @Emit("update:unselectedEntities") emitUnselected(arg: any[]) {
    return arg;
  }
  @Emit("selectionChangeManual") emitSelectionChangeManual() {
    return;
  }

  @Prop({ default: undefined })
  paginationModel: any;
  @Emit("update:paginationModel") emitPagination(arg: any) {
    return arg;
  }

  pageNum: number = 1;
  countOnPage: number = 1;

  querystore: any | undefined = undefined;
  auxstore: any | undefined = undefined;
  genstore: any | undefined = undefined;
  setstore: any | undefined = undefined;

  @Prop({ default: [] })
  srcElement?: BaseListItem;

  // instead takeAnything in the sector mode
  @Prop({ default: false })
  isSector?: boolean;
  @Prop({ default: false })
  isInDialog?: boolean;
  @Prop({ default: false })
  hidePanel?: boolean;
  @Prop({ default: [] })
  sectorEntityIds!: number[];

  // multiedit
  personEditDialog: boolean = false;
  persMarginX: number = 0;
  persMarginY: number = 0;
  personEditData: any = {};

  tagMultieditDialog: boolean = false;
  multiEditMode: number = 1;
  multiEditType: number = 1;
  multiEditHeader: string = "";
  // Стартовый режим окна комментария: 0 - дописать, 1 - заменить.
  multiEditCommentAction: number = 0;
  liteMultieditMenuVisible: boolean = false;
  liteMultieditMenuPos: { top: string; left: string } = { top: "0px", left: "0px" };
  multieditAnchorRect: DOMRect | null = null;
  multieditDialogPos = { x: 0, y: 0 };

  WA: boolean = false;

  @Setup((props, ctx) => {
    const $q = useQuasar();
    return {
      showNotification(msg: string) {
        $q.notify({
          color: "white",
          textColor: "grey-8",
          icon: undefined,
          message: msg,
          position: "top",
          timeout: 1000,
        });
      },
    };
  })
  data: any;

  openPermitionsModal() {
    this.closeLiteMultieditMenu();

    const sourceIds =
      this.headerCheckbox === "none"
        ? this.selectedModel
        : (this.modelValue?.DataRows ?? [])
            .map((row) => row.EntityId)
            .filter((id) => !this.unselectedModel.includes(id));
    const selectedIds = sourceIds.filter(
      (id: unknown): id is number =>
        typeof id === "number" && Number.isFinite(id),
    );
    if (!selectedIds.length || this.srcElement?.DestType === undefined) return;

    const modal = this.$refs["analyticPermitionModal"] as {
      onOpen: (selectedIds: number[], destType: number) => Promise<void>;
    } | null;
    modal?.onOpen(selectedIds, this.srcElement.DestType);
  }

  onPermitionsSaved() {
    this.emitRefreshPage(this.pagination);
  }

  get lastCalcDate() {
    if (!this.modelValue || !this.modelValue.SavedStateCalculatedAt) {
      return "";
    }
    return date.formatDate(
      this.modelValue?.SavedStateCalculatedAt,
      "DD.MM.YY HH:mm"
    );
  }

  get entitiesForMultiedit() {
    if (!this.isSector) {
      return this.headerCheckbox !== "none"
        ? this.unselectedModel
        : this.selectedModel;
    } else {
      if (this.headerCheckbox !== "none") {
        // this.sectorEntityIds.filter(n => !this.unselectedModel.includes(n))
        let res: number[] = [];
        for (let i = 0; i < this.sectorEntityIds.length; i++) {
          const n = this.sectorEntityIds[i];
          if (!this.unselectedModel.includes(n)) {
            res.push(n);
          }
        }
        return res;
      } else {
        return this.selectedModel;
      }
    }
  }

  updatePerson(event: MouseEvent, p_id: number) {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    let touchY = event.clientY;
    if (height - event.clientY < 250) {
      touchY -= 200;
    }

    this.persMarginX = -((width - 280) / 2 - event.screenX);
    this.persMarginY = -((height - 200) / 2 - touchY);

    this.personEditData = {
      personId: p_id,
    };
    this.personEditDialog = true;
  }

  saveTableToFile(arg: any, name: string) {
    if (this.auxstore) {
      if (this.isSector) {
        this.auxstore.downloadSectorTableFile(
          arg,
          this.sectorEntityIds,
          this.pagination,
          name
        );
      } else {
        this.auxstore.downloadTableFile(arg, name);
      }
    }
  }

  async copyUrl(l: string) {
    const el = document.createElement("textarea");
    el.value = l;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const sel = document.getSelection();
    const selected = sel && sel.rangeCount > 0 ? sel.getRangeAt(0) : false;
    el.select();

    document.execCommand("copy");
    this.data.showNotification(
      this.$t("link_to_item") +
        ' "' +
        this.genstore.selectedItem.Name +
        '" ' +
        this.$t("copied_to_clipboard")
    );

    document.body.removeChild(el);
    if (sel && selected) {
      sel.removeAllRanges();
      sel.addRange(selected);
    }
  }

  copyLinkToItem() {
    if (this.genstore.selectedItem.Id) {
      console.log("copy link " + this.genstore.selectedItem.Id);
      // setTimeout(() => {
      const l = buildClientUrl(
        "analyticsvue?type=" +
        this.genstore.selectedItem.elType +
        "&src=" +
        (this.genstore.selectedItem.SrcType === undefined
          ? ""
          : this.genstore.selectedItem.SrcType) +
        "&dest=" +
        this.genstore.selectedItem.DestType +
        "&id=" +
        this.genstore.selectedItem.Id);

      console.log(l);
      this.copyUrl(l);
    }
  }

  /*
    Признак основной таблицы Analytics в standalone-режиме. Только в этом случае
    родительский q-page переведён в flex-колонку (класс qpage--table-flex в
    Analytics.vue), поэтому обёртка может просто забрать оставшуюся высоту через
    flex. Превью (hidePanel) и сектор/диалог сюда НЕ попадают — там родитель не
    flex, и flex:1 схлопнул бы таблицу.
  */
  get isStandaloneMainLite(): boolean {
    return !this.isSector && !this.isInDialog && !this.hidePanel;
  }

  /*
    Стиль внешней обёртки таблицы.
    - Основная lite-таблица Analytics: q-page — flex-колонка, поэтому обёртка
      забирает оставшуюся высоту (flex: 1 1 0 + min-height: 0), а тело таблицы
      скроллится внутри. Нижний отступ даёт padding самого q-page. overflow:
      hidden — чтобы у обёртки не было своей прокрутки.
    - Сектор/диалог: прежнее поведение (auto, высоту задаёт контейнер вокруг).
    - Превью/standalone: прежняя фиксированная высота окна.
  */
  get wrapperStyle(): string {
    const flexBase = "display: flex; flex-flow: column;";
    if (this.isStandaloneMainLite) {
      // фон прозрачный: вокруг панели и карточки таблицы просвечивает фон страницы (#F2F2F2)
      return `overflow: hidden; flex: 1 1 0; min-height: 0; background: transparent; overscroll-behavior: none; ${flexBase}`;
    }
    if (this.isSector) {
      // В секторе таблица растёт во всю высоту, а прокручивается вся страница. Обёртка
      // НЕ должна быть скролл-контейнером: при overflow: auto вместе с
      // overscroll-behavior: none прокрутка колесом над панелью/таблицей не доходила бы
      // до страницы (цепочка прокрутки заблокирована). Поэтому overflow: visible и без
      // overscroll-behavior. Горизонтальный скролл широкой таблицы берёт на себя
      // корневой контейнер графика.
      return `overflow: visible; background: #fff; ${flexBase}`;
    }
    if (this.isInDialog) {
      return `overflow: auto; background: #fff; overscroll-behavior: none; ${flexBase}`;
    }
    return `overflow: auto; height: calc(100vh - 50px); padding-bottom: 8px; background: #fff; overscroll-behavior: none; ${flexBase}`;
  }

  onLiteMultieditClick(ev: MouseEvent) {
    if (!this.WA || !this.multieditAllowed) return;
    const x = Math.max(8, ev.clientX || 0);
    const y = Math.max(8, ev.clientY || 0);
    this.liteMultieditMenuPos = { top: `${y}px`, left: `${x}px` };
    this.liteMultieditMenuVisible = true;
  }

  closeLiteMultieditMenu() {
    this.liteMultieditMenuVisible = false;
  }

  // commentAction: 0 - дописать, 1 - заменить. Задаёт стартовый режим в окне комментария.
  onLiteMenuAction(
    type: number,
    mode: number,
    header: string,
    commentAction?: number,
    ev?: MouseEvent,
  ) {
    const itemEl = ev?.currentTarget as HTMLElement | undefined;
    if (itemEl) {
      this.multieditAnchorRect = itemEl.getBoundingClientRect();
    } else {
      const left = parseFloat(this.liteMultieditMenuPos.left) || 8;
      const top = parseFloat(this.liteMultieditMenuPos.top) || 8;
      this.multieditAnchorRect = new DOMRect(left, top, 200, 28);
    }
    this.closeLiteMultieditMenu();
    this.openMultiEdit(type, mode, header, commentAction);
  }

  get multieditDialogPosStyle() {
    return {
      left: `${this.multieditDialogPos.x}px`,
      top: `${this.multieditDialogPos.y}px`,
    };
  }

  closeMultieditDialog() {
    this.tagMultieditDialog = false;
  }

  adjustMultieditDialogPosition() {
    const wrap = this.$refs.multieditDialogWrap as HTMLElement | undefined;
    if (!wrap || !this.multieditAnchorRect) return;

    const margin = 8;
    const gap = 4;
    const width = wrap.offsetWidth;
    const height = wrap.offsetHeight;
    const rect = this.multieditAnchorRect;

    let x = rect.right + gap;
    let y = rect.top;
    if (x + width > window.innerWidth - margin) {
      x = rect.left - gap - width;
    }
    x = Math.min(Math.max(margin, x), Math.max(margin, window.innerWidth - width - margin));
    y = Math.min(Math.max(margin, y), Math.max(margin, window.innerHeight - height - margin));
    this.multieditDialogPos = { x, y };
  }

  onMultieditDocumentMousedown(e: MouseEvent) {
    if (!this.tagMultieditDialog) return;

    const target = e.target as Node;
    const wrap = this.$refs.multieditDialogWrap as HTMLElement | undefined;
    if (wrap?.contains(target)) return;

    const el = target as Element;
    if (
      el.closest?.(
        ".mosta-context-menu, .mosta-select__dropdown, .mtree-select__dropdown, .selector-popup, .dp__menu, .dp__menu_wrap, .q-menu, .ble-lite-menu",
      )
    ) {
      return;
    }

    this.closeMultieditDialog();
  }

  bindMultieditDialogListeners(active: boolean) {
    if (active) {
      document.addEventListener("mousedown", this.onMultieditDocumentMousedown, true);
      window.addEventListener("resize", this.adjustMultieditDialogPosition, true);
    } else {
      document.removeEventListener("mousedown", this.onMultieditDocumentMousedown, true);
      window.removeEventListener("resize", this.adjustMultieditDialogPosition, true);
    }
  }

  @Watch("tagMultieditDialog")
  onMultieditDialogToggle(open: boolean) {
    this.bindMultieditDialogListeners(open);
    if (open) {
      this.$nextTick(() => this.adjustMultieditDialogPosition());
    }
  }

  beforeUnmount() {
    this.bindMultieditDialogListeners(false);
  }

  get liteMenuText() {
    return {
      addToList: this.$t("add_to_list"),
      deleteFromList: this.$t("delete_from_list"),
      deleteElements: this.$t("delete_elements"),
      addTags: this.$t("add_tags"),
      changeTagsStatus: this.$t("change_tags_status"),
      removeTags: this.$t("remove_tags"),
      addParameters: this.$t("add_parameters"),
      editParameter: this.$t("edit_parameter"),
      deleteParameters: this.$t("delete_parameters"),
      // Заголовок окна общий для правки и дополнения: режим внутри выбирается селектом.
      changeComment: this.$t("change_comment"),
      changeDetails: this.$t("change_details"),
    };
  }

  // Пункт с точкой входа инфо нужен только движениям: у позиций тем же окном
  // открывается пункт параметров
  get showDetailsEntry(): boolean {
    return this.srcElement?.DestType === 8 && this.canEditDetails;
  }

  // Остаётся сегментам, где нет ни параметров, ни инфо: у них это единственный вход в окно
  get showCommentEntry(): boolean {
    if (this.srcElement && [0, 1, 7].includes(this.srcElement.DestType)) return false;
    return !this.showDetailsEntry;
  }

  // Пункт массовой правки комментариев показываем только если колонка есть в таблице
  get hasTableCommentColumn(): boolean {
    return !!this.modelValue?.HeaderRow?.some(
      (cont: TableHeaderCellContainer) => cont.Cells?.some(
        (c: TableHeaderCell) => c.Category === ColumnCategory.TableComments,
      ),
    );
  }

  get pagination() {
    return this.paginationModel;
  }

  set pagination(arg) {
    this.emitPagination(arg);
  }

  get currentPage(): number {
    this.pageNum =
      Math.round(
        this.pagination.offset / Number(this.auxstore.getTableRowCount)
      ) + 1;
    return (
      Math.round(
        this.pagination.offset / Number(this.auxstore.getTableRowCount)
      ) + 1
    );
  }

  get pagesCount(): number {
    return Math.ceil(
      this.pagination.total_count / Number(this.auxstore.getTableRowCount)
    );
  }

  // Число элементов в таблице показываем с разбивкой целой части по тройкам
  // (1 000, 250 000), пробел-разделитель — как в форматировании чисел в ячейках.
  get formattedTotalCount(): string {
    const n = Number(this.pagination.total_count);
    if (!isFinite(n)) return String(this.pagination.total_count ?? "");
    return Math.trunc(n)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  setCurrentPage(arg: number) {
    this.pagination.offset = (Number(arg) - 1) * this.auxstore.getTableRowCount;
    this.onRefreshTable(this.pagination, false);
  }

  setCountOnPage(arg: number) {
    this.auxstore.setTableRowCount(arg);

    // recalc offset
    this.pagination.offset =
      Math.floor(
        Number(this.pagination.offset) /
          (Number(arg) <= Number(this.pagination.total_count)
            ? Number(arg)
            : Number(this.pagination.total_count))
      ) * arg;
    this.pagination.forceInitial = true;
    this.onRefreshTable(this.pagination, false);
  }

  applyPageNum() {
    // Текущую страницу считаем локально, без геттера currentPage: он попутно пишет
    // в this.pageNum, и сравнение после такого чтения всегда давало бы равенство.
    const rpp = Number(this.auxstore.getTableRowCount);
    const actualPage = Math.round(Number(this.pagination.offset) / rpp) + 1;
    if (
      isNumber(this.pageNum) &&
      this.pageNum > 0 &&
      this.pageNum <=
        Math.ceil(
          this.pagination.total_count / Number(this.auxstore.getTableRowCount)
        )
    ) {
      // Значение не изменилось — не перезапрашиваем. Иначе blur (скролл, клик,
      // переключение таба отнимают фокус у инпута) слал бы AnotherPage заново
      // с тем же offset и параметрами.
      if (Number(this.pageNum) === actualPage) return;
      this.setCurrentPage(this.pageNum);
    } else {
      this.pageNum = 1;
      // Уже на первой странице — только чиним значение в инпуте, без перезапроса.
      if (actualPage === 1) return;
      this.setCurrentPage(1);
    }
  }

  applyCountOnPage() {
    if (isNumber(this.countOnPage) && this.countOnPage > 0) {
      // Кол-во строк на странице не изменилось — не перезапрашиваем (тот же случай
      // лишнего blur, что и у номера страницы).
      if (Number(this.countOnPage) === Number(this.auxstore.getTableRowCount)) {
        return;
      }
      if (this.srcElement) {
        const oldObjStr = localStorage.rowcount;
        if (oldObjStr) {
          let oldObj = JSON.parse(oldObjStr);
          oldObj[
            "tbl_" +
              this.srcElement?.Id +
              "_" +
              this.srcElement?.DestType +
              "_" +
              this.srcElement?.SrcType
          ] = this.countOnPage;
          localStorage.rowcount = JSON.stringify(oldObj);
        } else {
          let oldObj: any = {};
          oldObj[
            "tbl_" +
              this.srcElement?.Id +
              "_" +
              this.srcElement?.DestType +
              "_" +
              this.srcElement?.SrcType
          ] = this.countOnPage;
          localStorage.rowcount = JSON.stringify(oldObj);
        }
      }

      this.setCountOnPage(this.countOnPage);
    } else {
      this.countOnPage = this.auxstore.getTableRowCount;
    }
  }

  get selectedModel() {
    return this.selectedEntities || [];
  }

  get unselectedModel() {
    return this.unselectedEntities || [];
  }

  get headerCheckbox() {
    return this.selectedEverything || "none";
  }

  set selectedModel(arg: any) {
    this.emitSelected(arg);
  }

  set unselectedModel(arg: any) {
    this.emitUnselected(arg);
  }

  set headerCheckbox(arg: string) {
    this.emitSelectedAll(arg);
  }

  // checkboxes
  entityChecked(entityId: number) {
    return this.headerCheckbox === "none"
      ? this.selectedModel.includes(entityId)
      : !this.unselectedModel.includes(entityId);
  }

  @Watch("headerCheckbox")
  main_checkbox_watcher(arg: string) {
    if (arg === "all") {
      this.unselectedModel.splice(0);
    } else if (arg === "none") {
      this.selectedModel.splice(0);
    }
  }

  // Кнопка "карандаш +" в строке: включаем колонку комментария в настройках отображения
  // и мягко обновляем таблицу тем же путём, что и смена страницы, чтобы вертикальный
  // скролл остался на месте, а загрузка шла полоской под шапкой.
  async onAddCommentColumn(entityId: number) {
    const column = this.findCommentColumn(this.setstore?.getAllColumns || []);
    if (!column || column.Selected) {
      return;
    }

    // Флаг снимает сама таблица, когда начнётся загрузка данных: onRefreshTable отдаёт
    // управление раньше запроса, поэтому здесь его гасить нельзя. Таймер - страховка на
    // случай, если запрос так и не пошёл, чтобы таблица не осталась заблокированной.
    commentColumnBusy.value = true;
    setTimeout(() => { commentColumnBusy.value = false; }, 8000);

    try {
      column.Selected = true;
      await this.setstore.updateColumnSelection(column);
      requestCommentEdit(entityId);
      await this.onRefreshTable(this.pagination, false);
    } catch (e) {
      commentColumnBusy.value = false;
      clearCommentEditRequest();
    }
  }

  private findCommentColumn(list: any[]): any | undefined {
    for (const col of list) {
      if (col?.Category === ColumnCategory.TableComments) {
        return col;
      }
      if (col?.ChildColumns?.length) {
        const found = this.findCommentColumn(col.ChildColumns);
        if (found) return found;
      }
    }
    return undefined;
  }

  async onRefreshTable(
    pag: any,
    recalc: boolean = true,
    options?: { clearSelection?: boolean },
  ) {
    const clearSelection = options?.clearSelection;

    this.selectedModel.splice(0);
    this.unselectedModel.splice(0);
    this.headerCheckbox = "none";
    this.tagMultieditDialog = false;
    this.personEditDialog = false;

    if (localStorage.rowcount) {
      const countObjectStored = JSON.parse(localStorage.rowcount);
      const countStored =
        countObjectStored[
          "tbl_" +
            this.genstore.selectedItem.Id +
            "_" +
            this.genstore.selectedItem.DestType +
            "_" +
            this.genstore.selectedItem.SrcType
        ];

      if (countStored) {
        this.pagination.count = countStored;
        this.auxstore.setTableRowCount(countStored);
      } else {
        this.pagination.count = Number(this.auxstore.getDefaultRowCount);
        this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount);
      }
    } else {
      this.pagination.count = Number(this.auxstore.getDefaultRowCount);
      this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount);
    }

    if (this.isSector) {
      this.emitRefreshPage(this.pagination);
    } else {
      const that = this;
      setTimeout(async () => {
        const old_offset = this.pagination.offset;

        if (recalc) {
          that.pagination.recalculate = true;
          that.pagination.forceInitial = false;
          that.pagination.offset = 0;
          that.pagination.sortMode = this.pagination.sortMode;
          that.pagination.sortCategory = this.pagination.sortCategory;
          that.pagination.OrderingEntityIds =
            this.pagination.OrderingEntityIds || [];
          that.pagination.OrderByPinned = this.pagination.OrderByPinned;
          // TODO: do this also in main table, just emit pagination
          await that.querystore.getResultTable(
            that.srcElement,
            that.pagination,
            that.pagination.report,
            that.pagination.report_index
          );

          // recall not needed; recalculate = true resets all selection
          that.pagination.total_count = +that.querystore.getCurrentTable?.Count;
          that.pagination.OrderByPinned = that.querystore.getCurrentTable
            ? that.querystore.getCurrentTable.PinnedOptions.OrderByPinned
            : false;
        }

        if (old_offset > 0 || !recalc) {
          // and then to old page
          that.pagination.offset = old_offset;
          that.pagination.recalculate = false;
          that.pagination.forceInitial = false;
          await that.querystore.getResultTable(
            that.srcElement,
            that.pagination,
            that.pagination.report,
            that.pagination.report_index
          );
          that.pagination.OrderByPinned = that.querystore.getCurrentTable
            ? that.querystore.getCurrentTable.PinnedOptions.OrderByPinned
            : false;

          if (!clearSelection) {
            // recall selection
            that.headerCheckbox = !that.querystore.getCurrentTable.PinnedOptions
              .TakeAll
              ? "none"
              : that.querystore.getCurrentTable.PinnedOptions.PinnedEntities
                  ?.length
              ? "many"
              : "all";
            that.selectedModel = that.querystore.getCurrentTable.PinnedOptions
              .TakeAll
              ? []
              : that.querystore.getCurrentTable.PinnedOptions.PinnedEntities ||
                [];
            that.unselectedModel = that.querystore.getCurrentTable.PinnedOptions
              .TakeAll
              ? that.querystore.getCurrentTable.PinnedOptions.PinnedEntities || []
              : [];
          }
        }

        if (clearSelection) {
          that.headerCheckbox = "none";
          that.selectedModel = [];
          that.unselectedModel = [];
          that.emitSelectionChangeManual();
        }
        // recalc — одноразовый серверный флаг: сбрасываем безусловно. При recalc=true и
        // offset===0 второй блок (где он сбрасывался) не выполнялся, и флаг залипал в
        // общем объекте pagination, портя последующие запросы и видимость.
        that.pagination.recalculate = false;
      }, 300);
    }
  }

  prevPage() {
    if (this.pagination.offset - Number(this.auxstore.getTableRowCount) > 0) {
      this.pagination.offset -= Number(this.auxstore.getTableRowCount);
    } else {
      this.pagination.offset = 0;
    }
    this.pagination.recalculate = false;
    this.pagination.forceInitial = false;

    if (!this.isSector) {
      // TODO: do this also in main table, just emit pagination
      this.querystore.getResultTable(
        this.srcElement,
        this.pagination,
        this.pagination.report,
        this.pagination.report_index
      );
    } else {
      this.emitMovePage(this.pagination);
    }
  }

  nextPage() {
    this.pagination.offset += Number(this.auxstore.getTableRowCount);
    this.pagination.recalculate = false;
    this.pagination.forceInitial = false;

    if (!this.isSector) {
      // TODO: do this also in main table, just emit pagination
      this.querystore.getResultTable(
        this.srcElement,
        this.pagination,
        this.pagination.report,
        this.pagination.report_index
      );
    } else {
      this.emitMovePage(this.pagination);
    }
  }

  async globalPinnedOrder() {
    // Простой тоггл: всегда отправляем значение, противоположное текущему показанному
    // (текущее берём из pagination — оно отражает последний ответ). Никакой логики
    // "только включение": шлём и true, и false. Сортировку по закреплённым при
    // выключении сбрасываем (ColumnCategory=null), остальные параметры не трогаем.
    const target = !this.pagination.OrderByPinned;
    this.pagination.OrderByPinned = target;
    if (!target) {
      this.pagination.sortCategory = null;
    }
    // Принудительно на /Ordered, иначе с OrderByPinned=false запрос ушёл бы на /Initial
    // и флаг (в т.ч. false) не отправился бы.
    this.pagination.forceOrdered = true;

    if (!this.isSector) {
      this.pagination.recalculate = false;
      this.pagination.forceInitial = true;
      this.pagination.offset = 0;
      await this.querystore.getResultTable(
        this.srcElement,
        this.pagination,
        this.pagination.report,
        this.pagination.report_index
      );
      // Иконку показываем по факту: ровно то, что сервер вернул в PinnedOptions.
      this.pagination.OrderByPinned =
        this.querystore.getCurrentTable?.PinnedOptions?.OrderByPinned ?? false;
    } else {
      this.emitRefreshPage(this.pagination);
    }
  }

  emitSelectionChange() {
    this.emitSelectionChangeManual();
  }

  updateSelection(toggleState: boolean, entityId: number) {
    if (toggleState) {
      const f_index_s = this.selectedModel.findIndex(
        (el: number) => el === entityId
      );
      const f_index_u = this.unselectedModel.findIndex(
        (el: number) => el === entityId
      );
      if (f_index_s < 0) {
        this.selectedModel.push(entityId);
      }
      if (f_index_u >= 0) {
        this.unselectedModel.splice(f_index_u, 1);
      }
    } else {
      const f_index_s = this.selectedModel.findIndex(
        (el: number) => el === entityId
      );
      const f_index_u = this.unselectedModel.findIndex(
        (el: number) => el === entityId
      );
      if (f_index_s >= 0) {
        this.selectedModel.splice(f_index_s, 1);
      }
      if (f_index_u < 0) {
        this.unselectedModel.push(entityId);
      }
    }
    if (this.headerCheckbox !== "none") {
      this.headerCheckbox = this.unselectedModel.length ? "many" : "all";
    }
  }

  // width function
  get widthOptions() {
    // multiplier to 100% = (value + 1) - value*0.5
    return [
      {
        label: this.$t("quarter_screen_width"),
        value: 5,
        multiplier: 0.25,
      },
      {
        label: this.$t("half_screen_width"),
        value: 6,
        multiplier: 0.5,
      },
      {
        label: this.$t("screen_0_75"),
        value: 7,
        multiplier: 0.75,
      },
      {
        label: this.$t("screen_width"),
        value: 0,
        multiplier: 1,
      },
      {
        label: this.$t("screen_1_25"),
        value: 8,
        multiplier: 1.25,
      },
      {
        label: this.$t("screenup_width"),
        value: 1,
        multiplier: 1.5,
      },
      {
        label: this.$t("screen_1_75"),
        value: 9,
        multiplier: 1.75,
      },
      {
        label: this.$t("double_screen_width"),
        value: 2,
        multiplier: 2,
      },
      {
        label: this.$t("doubleup_screen_width"),
        value: 3,
        multiplier: 2.5,
      },
      {
        label: this.$t("triple_screen_width"),
        value: 4,
        multiplier: 3,
      },
    ];
  }

  set widthModel(val: any) {
    this.theModel &&
      ((this.theModel as AnalyticsResultTableExtended).TableWidth = val.value);

    // if (this.auxstore && this.genstore && this.genstore.selectedItem && this.genstore.selectedItem.Id) {
    // this.auxstore.saveTableWidth(this.genstore.selectedItem.Id, val.value)
    // }
  }

  get widthModel(): any {
    return this.widthOptions.find(
      (opt) =>
        opt.value ===
        (this.theModel as AnalyticsResultTableExtended)?.TableWidth
    );
  }

  // count function
  get countOptions() {
    return [
      {
        label: "10",
        value: 10,
      },
      {
        label: "25",
        value: 25,
      },
      {
        label: "50",
        value: 50,
      },
      {
        label: "100",
        value: 100,
      },
    ];
  }

  set countModel(val: any) {
    this.auxstore.setTableRowCount(val.value);

    // recalc offset
    this.pagination.offset =
      Math.floor(Number(this.pagination.offset) / Number(val.value)) *
      val.value;
    // console.log('set count model')
    this.onRefreshTable(this.pagination, false);
  }

  get countModel(): any {
    return (
      this.countOptions.find(
        (opt) => opt.value === this.auxstore.getTableRowCount
      ) || this.auxstore.getTableRowCount
    );
  }

  // other hooks
  created() {
    this.querystore = queryStore();
    this.auxstore = auxStore();
    this.genstore = generalStore();
    this.setstore = settingsStore();
    this.countOnPage = this.auxstore.getTableRowCount;

    this.WA = this.genstore.accessRights.WriteAccess;
  }

  @Watch("theModel")
  @Watch("widthModel")
  mounted() {
    this.$nextTick(() => {
      if (!this.theModel || !this.theModel.HeaderRow) {
        return;
      }

      // Восстанавливаем сохранённое число строк на странице для этой выборки —
      // верхняя панель (общая для таблицы) читает countOnPage. Остальную обработку
      // данных ведёт сам QueryTableLite (useTableModel), здесь считать нечего.
      try {
        const countObjectStored = JSON.parse(localStorage.rowcount);
        const countStored =
          countObjectStored[
            "tbl_" +
              this.srcElement?.Id +
              "_" +
              this.srcElement?.DestType +
              "_" +
              this.srcElement?.SrcType
          ];
        if (countStored) {
          this.countOnPage = countStored;
        }
      } catch (e: any) {
        console.log("take default page size");
      }
    });
  }

  // Массовая правка инфо это то же изменение элементов выборки, что и правка в ячейке,
  // поэтому пункты меню требуют обоих прав.
  get canEditDetails() {
    return canEditStorageDetails();
  }

  get multieditAllowed() {
    return (
      this.genstore.selectedItem.DestType !== 6 &&
      this.pagination.total_count > 0 &&
      !(
        this.headerCheckbox === "none" &&
        (!this.selectedModel || !this.selectedModel.length)
      )
    );
  }

  onMultiEditRefreshNeeded(payload: boolean | { recalc?: boolean; clearSelection?: boolean }) {
    if (this.multiEditType === 5 && this.multiEditMode === 1) {
      return;
    }

    const isObject = payload != null && typeof payload === "object";
    const clearSelection = isObject && !!payload.clearSelection;
    let recalc: boolean;

    if (isObject && payload.recalc !== undefined) {
      recalc = payload.recalc !== false;
    } else if (this.multiEditMode === 2) {
      recalc = true;
    } else if (this.multiEditType !== 5) {
      recalc = false;
    } else {
      recalc = true;
    }

    this.onRefreshTable(
      this.pagination,
      recalc,
      clearSelection ? { clearSelection: true } : undefined,
    );
  }

  openMultiEdit(type: number, mode: number, header: string, commentAction?: number) {
    if (!this.multieditAllowed) {
      this.tagMultieditDialog = false;
    } else {
      this.multiEditType = type;
      this.multiEditMode = mode;
      this.multiEditHeader = header;
      this.multiEditCommentAction = commentAction ?? 0;
      this.tagMultieditDialog = true;
      this.$nextTick(() => this.adjustMultieditDialogPosition());
    }
  }

  get theModel() {
    return this.modelValue;
  }

  set theModel(arg: any) {
    this.emitModelValue(arg);
  }
}
</script>

<style lang="scss">
/* Иконки в верхней панели над таблицей (обновить / выгрузить / поделиться):
   обычные кнопки с inline-svg (currentColor), как в сплиттере средней панели
   (см. toolbar-icon-btn в Analytics). Без рамки/фона, цвет через currentColor:
   покой #979797, наведение #3F884F, disabled #d2d2d2. */
.qt-panel-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 8px;
  height: 40px;
  /* Опускаем иконки на 3px под остальные элементы панели. На кнопках НЕ ставить
     Quasar-утилиты q-my-* (они с !important и перебьют этот margin-top). */
  margin-top: 3px;
  /* По 5px по бокам: между соседними иконками отступы складываются в 10px. */
  margin-left: 5px;
  margin-right: 5px;
  border: none;
  background: none;
  cursor: pointer;
  color: #979797;
}

/* В секторной таблице убираем внутренний padding: зазор между иконками задаём
   только боковыми margin (5px + 5px = 10px), без лишнего отступа от padding.
   Главную таблицу это не затрагивает - модификатор ставится только при isSector. */
.qt-panel-icon-btn--flat {
  padding: 0;
}

.qt-panel-icon-btn:not(:disabled):hover {
  color: #3F884F;
}

.qt-panel-icon-btn:disabled {
  color: #d2d2d2;
  cursor: default;
}

.mini-nav-btn {
  width: 24px;
  height: 24px;
  /* margin-top задаётся инлайн и зависит от режима панели (основная таблица /
     сектор графика / диалог): в секторе и диалоге соседние элементы подняты,
     поэтому стрелки выравниваем по ним. */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #7f7f7f;
  cursor: pointer;
  padding: 0;
}

.mini-nav-btn:hover:not(:disabled) {
  color: #3F884F;
}

.mini-nav-btn:disabled {
  color: #c8c8c8;
  cursor: default;
}

.med-dialog-popup {
  position: fixed;
  z-index: 5900;
  width: max-content;
  border-radius: 16px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.20);
}
</style>
